export interface IRecordIdentification {
    readonly className: string;
    readonly id: number | string; // TODO: OWObjectId
}

export class IRecordIdentification {
    private static _properties: (keyof IRecordIdentification)[] = ["className", "id"];
    private static _methods: (keyof IRecordIdentification)[] = [];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && typeof instance === "object" &&
            this._properties.every((value) => Reflect.has(instance, value)) &&
            this._methods.every(value => typeof instance[value] === "function");
    }
}
